import type { ShopDto, UpdateShopLocationDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateLocation(
  shop: ShopDto,
  shopLocationId: string,
) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation("patch", "/shops/{shopId}/locations/{shopLocationId}", {
    invalidate: invalidateShop,
    mapVariables: (requestBody: UpdateShopLocationDto) => ({
      params: { path: { shopId: shop.id, shopLocationId } },
      body: requestBody,
    }),
  });
}
